import Vue from 'vue';
import store from './modules/localidades/store'
import App from './App.vue'
import router from './router'
import Argon from './plugins/argon-kit'
import './registerServiceWorker'
import VueLayers from 'vuelayers'
import bootstrapVue from 'bootstrap-vue'
import VueScrollactive from 'vue-scrollactive'
import VueResource from 'vue-resource'
import 'vuelayers/lib/style.css' // needs css-loader

Vue.use(bootstrapVue)
Vue.use(VueLayers)
Vue.use(VueResource)
Vue.use(Argon)
Vue.use(VueScrollactive)

Vue.config.productionTip = false
Vue.http.options.root = process.env.VUE_APP_JANELA_CONECTA_URI;
Vue.http.headers.common['JanelaConectaKey'] = process.env.VUE_APP_JANELA_CONECTA_KEY;

Vue.http.interceptors.push(function (request, next) {
  if (!requestsExcluded.find((item) => { return item === request.url.split('?')[0] }))
    interceptors(request, next)
})

const requestsExcluded = []

const interceptors = function (request, next) {
  next(function (response) {
     // some code
  })
}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
